import ButtonController from "./button-controller"

const buttonController = new ButtonController();

export {
    buttonController
}
